import { values } from "lodash";
import ReducersIndex from "reduxModules/ducks";
import { isInside } from "utilities/geometric";

const actions = {
  floorplan: {
    container: ['ghostdock'],
  },
  acoustics: {
    container: ['position', 'level', 'listen'],
    area: ['position', 'level', 'listen']
  },
  designpriority: {
    area: ['position', 'level', 'remove', 'listen']
  },
  speakers: {
    container: ['position', 'level', 'listen'],
    area: ['position', 'level', 'listen']
  },
  equipmentlist: {}
};

export const conditions = {
  position: { parameter: ['coverage', 'activeTab'], check: ([coverage, activeTab]) => activeTab === '_warehouse' || !coverage.none },
  level: { parameter: ['coverage', 'activeTab'], check: ([coverage, activeTab]) => activeTab === '_warehouse' || !coverage.none },
  remove: { parameter: ['coverage'], check: ([coverage]) => !coverage.none},
  listen: { parameter: ['coverage', 'activeTab'], check: ([coverage, activeTab]) => activeTab === '_warehouse' || !coverage.none },
};

export const actionDispatchers = {
  ghostdock: (_, dispatch, mouse, drawingBox) => {
    const target = document.getElementById('loadingdocks');
    const {x,y } = mouse;
    const {svgbox: {top, left}} = drawingBox;
    const point = [x + left, y + top];
    const dock = Array.from(target.children).find(child => isInside(point , child.getBoundingClientRect()));
    if (dock) dispatch(ReducersIndex.container.setGhostDocks(dock.id));
  },
  remove: (evt, dispatch) => {
    const target = evt.target.closest('[class=speakers]')?.id;
    if (target) {
      const [area, _, speakerId] = target.split('-');
      dispatch(ReducersIndex.container.deleteSpeaker({area: area, id: speakerId}));
    };
  },
};

export default actions;
